import { FC, useMemo, memo, CSSProperties } from 'react'

import { Link } from '~/components/Link'
import { TopicOverview } from '~/types/theory'
import { getTopicClassName } from '~/encyclopedia/utils/encyclopedia.utils'

interface SubjectButtonProps {
  topic: TopicOverview
  show: boolean
  isSelectedTopic: (topic: TopicOverview) => boolean
  findNextUrl: (topic: TopicOverview, disableToggle?: boolean) => string
  linkStyle?: CSSProperties
}

const SubjectButtonComponent: FC<SubjectButtonProps> = ({ topic, show, isSelectedTopic, findNextUrl, linkStyle }) => {
  const buttonToggle = show ? 'max-h-60' : 'max-h-0 pointer-events-none'
  const isSelected = useMemo(() => isSelectedTopic(topic), [topic, isSelectedTopic])
  const subjectHeight = isSelected ? 'max-h-fit-content xl:max-h-60' : 'max-h-0'

  return (
    <div className="my-3 leading-normal" key={topic.path}>
      <Link
        className={
          'p-0.5 md:p-1 pl-2 rounded-small text-left text-xxs overflow-hidden ' +
          `text-xs ${isSelected ? getTopicClassName(topic, 'only-text') : 'text-gray-link'} ` +
          `${buttonToggle} transition-all duration-500 ease-in-out`
        }
        style={linkStyle}
        to={findNextUrl(topic)}
      >
        {topic.h1}
      </Link>
      {topic.shouldRenderChildren && (
        <div className={`flex flex-col ml-8 overflow-hidden ${subjectHeight} transition-all duration-500 ease-in-out `}>
          {topic.children?.map((subTopic) => (
            <SubjectButton
              findNextUrl={findNextUrl}
              isSelectedTopic={isSelectedTopic}
              key={subTopic.path}
              linkStyle={{ fontSize: 12 }}
              show={isSelected}
              topic={subTopic}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export const SubjectButton = memo(SubjectButtonComponent)
